import { supabase } from '../lib/supabase'

const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY

export async function requestPushPermission(): Promise<NotificationPermission> {
  if (!('Notification' in window) || !('serviceWorker' in navigator)) return 'denied'
  return Notification.requestPermission()
}

export async function subscribeToPush(): Promise<void> {
  const registration = await navigator.serviceWorker.ready
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY) as any,
  })
  const { endpoint, keys } = subscription.toJSON() as { endpoint: string; keys: { p256dh: string; auth: string } }
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Usuário não autenticado')
  await supabase.from('push_subscriptions').upsert(
    { user_id: user.id, endpoint, p256dh: keys.p256dh, auth: keys.auth },
    { onConflict: 'endpoint' }
  )
}

export async function unsubscribeFromPush(): Promise<void> {
  const registration = await navigator.serviceWorker.ready
  const subscription = await registration.pushManager.getSubscription()
  if (!subscription) return
  await subscription.unsubscribe()
  await supabase.from('push_subscriptions').delete().eq('endpoint', subscription.endpoint)
}

export async function getNotificationPreferences() {
  const { data } = await supabase.from('notification_preferences').select('*').maybeSingle()
  return data
}

export async function saveNotificationPreferences(prefs: {
  push_enabled: boolean
  whatsapp_notify: boolean
  days_before: number
}) {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Usuário não autenticado')
  await supabase.from('notification_preferences').upsert(
    { user_id: user.id, ...prefs },
    { onConflict: 'user_id' }
  )
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = atob(base64)
  return Uint8Array.from(rawData, char => char.charCodeAt(0))
}
